module.exports = __webpack_public_path__ + "static/cbef5edcd5895b1da498fcaf2e91c6d81d81eb5852314a4e3a7f0e71578395d8-c80e7ee837653b25f00fbe319a909342.jpeg";